import React, { useCallback, useEffect, useState } from 'react'
import { useAppSelector } from '../../../store/hooks'
import { selectAccountId } from '../../../store/auth/authSlice'
import { SelectDropdown, SelectOption } from '../../../components/SelectDropdown/SelectDropdown'
import { useGetIntegrationTeamsQuery } from '../../../store/integrations/integrations'
import { Team } from '../../../models/User'
import { getContactDropdownComponent } from '../ContactDropdownItems'
import { IntegrationServiceId } from '../../../common/integrations'

export const TeamSelectDropdown: React.FC<{ serviceId: string; onOptionSelected: (optionId: string | null) => void }> = ({ serviceId, onOptionSelected }) => {
  const accountId = useAppSelector(selectAccountId)
  const [searchedTeamOptions, setSearchedTeamOptions] = useState<SelectOption[] | null>(null)

  const { data: teams, isFetching: isTeamsFetching } = useGetIntegrationTeamsQuery({ accountId, connector: serviceId })

  const getTeamOptions = useCallback(
    (teams: Team[]) => {
      return teams.map((team) => {
        const teamIntegration = team.integrations?.find((i) => i.serviceId === serviceId)
        const teamLabel = `${team.name ? team.name : ''}`
        return { id: teamIntegration!.externalId, label: teamLabel }
      })
    },
    [serviceId],
  )

  useEffect(() => {
    if (teams?.data) {
      setSearchedTeamOptions(getTeamOptions(teams.data))
    }
  }, [teams, getTeamOptions])

  const onTeamSearchInputChange = async (searchInput: string) => {
    if (!teams?.data) return

    if (!searchInput) {
      setSearchedTeamOptions(getTeamOptions(teams.data))
      return
    }

    const filteredTeams = teams.data.filter((team) => team.name?.toLowerCase().includes(searchInput.toLowerCase()))

    setSearchedTeamOptions(getTeamOptions(filteredTeams))
  }

  return (
    <SelectDropdown
      initialSelectedOption={null}
      options={searchedTeamOptions ?? []}
      className='py-2 zocks-px-0.75'
      onOptionSelected={(option) => onOptionSelected(option ? option.id : null)}
      onDeselect={() => onOptionSelected(null)}
      DropDownItemOptionComponent={getContactDropdownComponent(serviceId as IntegrationServiceId)}
      searchable={true}
      loading={isTeamsFetching}
      onSearchInputChange={onTeamSearchInputChange}
      placeholder='Select team'
      showDeselectOption={true}
      deselectOptionLabel={'Deselect team'}
      forceDefaultDeselectOptionComponent={true}
    />
  )
}
